import { Inputs, validationSchema } from '@/entities/Faq/FaqFormInputs';

const FaqFormMap = {
	Plural: 'FAQs',
	Single: 'FAQ',
	Inputs: Inputs,
	Relationships: [],
	ValidationSchema: validationSchema,
};

export default FaqFormMap;
